import { FigmaImage, PanesContainer, useNotionDatabase } from "dev";
import { ProgressBar } from "ui/delivery";

import { Status, Substatus } from "@/src/types";

export default function ProgressBars() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  if (!db) return null;

  const data = db.map((r) => {
    const status = r["Status"] as Status;
    const substatus = r["Sub-status"] as Substatus<Status>;
    const figma_url = r["Consumer Figma Link"];

    return { status, substatus, figma_url };
  });

  return (
    <PanesContainer
      items={data}
      renderItem={({ status, substatus, figma_url }, index) => (
        <>
          <>
            <span>status: {status}</span>
            <span>substatus: {substatus}</span>
          </>

          <FigmaImage url={figma_url} fetchDelayMs={index * 100} />

          <ProgressBar
            status={status}
            substatus={substatus}
            carrier="multientrega"
          />
        </>
      )}
    />
  );
}
